import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPublicPageView } from '../../services/visitorServices';

export default function VisitorTracking() {
  const location = useLocation();
  const lastPathRef = useRef('');

  useEffect(() => {
    const path = `${location.pathname}${location.search}`;
    if (!path || path === lastPathRef.current) return;
    lastPathRef.current = path;

    trackPublicPageView({
      path,
      title: document.title,
    });
  }, [location]);

  return null;
}
